import { Flex, Text } from '@chakra-ui/react';

import { DropzoneOcr } from './DropzoneOcr';

interface OcrStagedDropzoneProps {
  isSubmitting: boolean;
  maxSizeMb?: number;
  maxW?: string | { base: string; md: string };
  onFilesSelected: (files: File[]) => void;
  onReady?: (open: (() => void) | null) => void;
  remainingFileSlots: number;
}

export const OcrStagedDropzone = ({
  isSubmitting,
  maxSizeMb = 5,
  maxW,
  onFilesSelected,
  onReady,
  remainingFileSlots,
}: OcrStagedDropzoneProps) => {
  if (remainingFileSlots > 0) {
    return (
      <DropzoneOcr
        disabled={isSubmitting}
        maxFiles={remainingFileSlots}
        maxSizeMb={maxSizeMb}
        maxW={maxW}
        onFilesSelected={onFilesSelected}
        onReady={onReady}
      />
    );
  }

  return (
    <Flex
      align="center"
      bg="#F1F8FF"
      borderRadius="8px"
      justify="center"
      minH="96px"
      px={4}
    >
      <Text color="blue" fontSize="16px" fontWeight={600}>
        Maksimal 5 file telah terupload
      </Text>
    </Flex>
  );
};
